import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue";
const _hoisted_1 = ["innerHTML"];
const _hoisted_2 = { class: "share__link-title" };
const _hoisted_3 = { class: "share__link-text" };
const _hoisted_4 = { class: "share__access" };
const _hoisted_5 = { class: "share__url" };
const _hoisted_6 = ["href"];
import { ref, watch } from 'vue';
import env from '../services/AppEnv';
import ModalForm from "@astina/paloma-common-ui/src/components/ModalForm.vue";
import CopyToClipboard from "@astina/paloma-common-ui/src/components/CopyToClipboard.vue";
import { saveWatchlistSharingSettings as saveWatchlistSharingSettingsUpstream } from "../commands/SaveWatchlistSharingSettings";
import customers from "@astina/paloma-shop-common-ui/src/services/CustomerRepository";
import config from '../services/PortalConfig';
import CommandButton from "@astina/paloma-common-ui/src/components/CommandButton.vue";
import ResetWatchlistAccessCode from "../commands/ResetWatchlistAccessCode";
export default /*@__PURE__*/ _defineComponent({
    __name: 'WatchlistShare',
    props: {
        watchlist: {}
    },
    emits: [
        'cancel',
        'save'
    ],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const shareForm = ref(null);
        const shareSettings = ref({
            enabled: props.watchlist.shareStatus === 'enabled',
            publicName: props.watchlist.publicName || props.watchlist.name
        });
        const loading = ref(false);
        const saved = ref(false);
        const showDisableWarning = ref(false);
        const accessTokenExtension = ref(config.extensions.watchlistAccessToken);
        const resetAccessCodeCommand = ref(null);
        customers.getWatchlistShareForm().then(form => shareForm.value = form);
        init();
        watch(() => props.watchlist, init);
        function init() {
            shareSettings.value = {
                enabled: props.watchlist.shareStatus === 'enabled',
                publicName: props.watchlist.publicName || props.watchlist.name
            };
            resetAccessCodeCommand.value = new ResetWatchlistAccessCode(props.watchlist.watchlistId);
        }
        watch(() => shareSettings.value?.enabled, onEnableDisable);
        function onEnableDisable() {
            showDisableWarning.value = !shareSettings.value.enabled && !!props.watchlist.accessToken;
        }
        function shareUrl() {
            return env.customer.watchlistShareUrlPattern.replace('{accessToken}', props.watchlist.accessToken);
        }
        function saveWatchlistSharingSettings() {
            if (!shareSettings.value) {
                return;
            }
            loading.value = true;
            saved.value = false;
            const shareSettingsLocal = {
                shareStatus: shareSettings.value.enabled ? 'enabled' : 'disabled',
                publicName: shareSettings.value.publicName,
                shareUntil: shareSettings.value.shareUntil,
            };
            saveWatchlistSharingSettingsUpstream(props.watchlist.watchlistId, shareSettingsLocal)
                .then(() => emit('save'))
                .finally(() => {
                loading.value = false;
                saved.value = true;
                window.setTimeout(() => saved.value = false, 500);
            });
        }
        function onAccessTokenReset() {
            emit('save');
        }
        return (_ctx, _cache) => {
            return (shareForm.value)
                ? (_openBlock(), _createBlock(ModalForm, {
                    key: 0,
                    onSubmit: _cache[1] || (_cache[1] = ($event) => (saveWatchlistSharingSettings())),
                    onCancel: _cache[2] || (_cache[2] = ($event) => (_ctx.$emit('cancel'))),
                    form: shareForm.value,
                    data: shareSettings.value,
                    title: _ctx.$t('watchlist.share_settings'),
                    "submit-label": _ctx.$t('save'),
                    "cancel-label": _ctx.$t('close'),
                    "submit-icon": "save",
                    loading: loading.value,
                    "modal-size": "medium"
                }, {
                    content: _withCtx(() => [
                        (_ctx.$te('watchlist.share_info_url_text'))
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "share__info",
                                innerHTML: _ctx.$t('watchlist.share_info_url_text', { url: _ctx.$t('watchlist.share_info_url') })
                            }, null, 8, _hoisted_1))
                            : _createCommentVNode("", true)
                    ]),
                    footer: _withCtx(() => [
                        (__props.watchlist.shareStatus === 'enabled')
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(["modal__footer share__link", { 'share__link--highlight': saved.value, 'share__link--warning': showDisableWarning.value }])
                            }, [
                                _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.$t(showDisableWarning.value ? 'watchlist.share_disable_title' : 'watchlist.share_link_title')), 1),
                                _cache[5] || (_cache[5] = _createTextVNode()),
                                _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t(showDisableWarning.value ? 'watchlist.share_disable_text' : 'watchlist.share_link_text')), 1),
                                _cache[6] || (_cache[6] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("div", _hoisted_5, [
                                        _createElementVNode("a", {
                                            href: shareUrl(),
                                            target: "_blank"
                                        }, _toDisplayString(shareUrl()), 9, _hoisted_6),
                                        _cache[3] || (_cache[3] = _createTextVNode()),
                                        _createVNode(CopyToClipboard, {
                                            value: shareUrl()
                                        }, null, 8, ["value"])
                                    ]),
                                    _cache[4] || (_cache[4] = _createTextVNode()),
                                    (resetAccessCodeCommand.value)
                                        ? (_openBlock(), _createBlock(CommandButton, {
                                            key: 0,
                                            command: resetAccessCodeCommand.value,
                                            classes: ['button', 'button--icon'],
                                            title: _ctx.$t('watchlist.reset_access_token'),
                                            disabled: showDisableWarning.value,
                                            label: '',
                                            onSuccess: _cache[0] || (_cache[0] = ($event) => (onAccessTokenReset()))
                                        }, null, 8, ["command", "title", "disabled"]))
                                        : _createCommentVNode("", true)
                                ]),
                                _cache[7] || (_cache[7] = _createTextVNode()),
                                (accessTokenExtension.value)
                                    ? (_openBlock(), _createBlock(_resolveDynamicComponent(accessTokenExtension.value), {
                                        key: 0,
                                        props: { watchlist: __props.watchlist, saved: saved.value }
                                    }, null, 8, ["props"]))
                                    : _createCommentVNode("", true)
                            ], 2))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }, 8, ["form", "data", "title", "submit-label", "cancel-label", "loading"]))
                : _createCommentVNode("", true);
        };
    }
});
